export enum UserAvatarTypeEnum {
  Header = "header",
  HeaderSmall = "header-small",
  Catalog = "catalog",
  Call = "call",
  CallSmall = "call-small",
  Appointment = "appointment",
  Circle = "circle",
  Profile = "profile",
  Stories = "stories",
  Chat = "chat",
  Lobby = "lobby"
}

export type UserAvatarProps = {
  mobileImage?: {
    twox: string,
    threex: string,
  },
  desktopImage?: {
    twox: string,
    threex: string,
  }
  name?: string;
  userId?: number;
  type?: UserAvatarTypeEnum;
  expertCategory?: string | null;
  badgeText?: string;
};
